import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import "swiper/swiper.css";
import "./swiper-fix.css";

// import required modules
import { Pagination, Navigation } from "swiper/modules";
import ClientsJobCard from "../../pages/Clients/components/ClientsJobCard";

function JobSwiper({
  data,
  setJobListing,
  fetchDetails,
  handleMoveJobCandidates,
  handleMoveJobDetails,
  slidesPerView = 2,
}) {
  return (
    <>
      <Swiper
        slidesPerView={slidesPerView}
        navigation={true}
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination, Navigation]}
        className="mySwiper"
      >
        {data.map((job, index) => (
          <SwiperSlide key={index}>
            <div className="">
              <ClientsJobCard
                job={job}
                setJobListing={setJobListing}
                slidesPerView={slidesPerView}
                fetchDetails={fetchDetails}
                handleMoveJobCandidates={handleMoveJobCandidates}
                handleMoveJobDetails={handleMoveJobDetails}
              />{" "}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

export default JobSwiper;
